import { render, staticRenderFns } from "./HowToRequestInfo.vue?vue&type=template&id=64f6dfa2&scoped=true&"
import script from "./HowToRequestInfo.vue?vue&type=script&lang=js&"
export * from "./HowToRequestInfo.vue?vue&type=script&lang=js&"
import style0 from "./HowToRequestInfo.vue?vue&type=style&index=0&id=64f6dfa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f6dfa2",
  null
  
)

export default component.exports